import axios from '../../../axios';
import ICareerPageSettingDTO from '../types/ICareerPageSettingDTO';

const settingsUrl = '/recruitersearch/api/career-page';
const emailAccounts = '/emailingapp/api/recruiter-smtp-accounts';

export const saveCareerPageSettings = (careerPageSettingDTO: ICareerPageSettingDTO) =>
  axios.post(`${settingsUrl}`, careerPageSettingDTO);
export const getCareerPageSettings = () => axios.get(`${settingsUrl}`);
export const getRecruiterEmailAccount = () => axios.get(`${emailAccounts}`);
export const getCareerPageBySlug = (slug: string) => axios.get(`${settingsUrl}/slug/${slug}`);
export const getCareerPageByDomain = (domain: string) =>
  axios.get(`${settingsUrl}/domain/${domain}`);
